(() => {
  const AI_SELECTORS = [
    '.entrypoint-shadow',
    '.shop-ai-chat-container',
    '#shop-ai-chat',
    '#shop-ai-chat-container',
    '[aria-label*="Shop with AI" i]',
    '[title*="Shop with AI" i]',
    'iframe[title*="Shop with AI" i]'
  ];

  const IS_SEARCH = window.themeVariables?.settings?.pageType === 'search';
  const IS_HOME = window.themeVariables?.settings?.pageType === 'index';
  const IS_COLLECTION = window.themeVariables?.settings?.pageType === 'collection';
  const IS_BUCKET_COLLECTION = IS_COLLECTION
    && /\/collections\/bucket(?:\/|$)/.test(window.location.pathname);
  const IS_PRODUCT = window.themeVariables?.settings?.pageType === 'product';
  const IS_ABOUT = window.themeVariables?.settings?.pageType === 'page'
    && /\/pages\/chokolids-headwear\/?$/.test(window.location.pathname);
  const IS_LOOKBOOK = window.themeVariables?.settings?.pageType === 'page'
    && /\/pages\/lookbook\/?$/.test(window.location.pathname);
  const IS_REVIEWS = window.themeVariables?.settings?.pageType === 'page'
    && /\/pages\/reviews\/?$/.test(window.location.pathname);
  const IS_CONTACT = window.themeVariables?.settings?.pageType === 'page'
    && /\/pages\/contact-us\/?$/.test(window.location.pathname);
  const IS_CUSTOM = window.themeVariables?.settings?.pageType === 'page'
    && /\/pages\/custom\/?$/.test(window.location.pathname);
  const IS_SUPPORT_PAGE = /\/(?:pages\/(?:shipping-information|privacy-policy|guarantee|returns-policy|wholesaleregistration)|policies\/terms-of-service)\/?$/.test(window.location.pathname);
  const USE_HOME_WIDGET_LAYOUT = IS_SEARCH || IS_HOME || IS_COLLECTION || IS_PRODUCT || IS_ABOUT || IS_LOOKBOOK || IS_REVIEWS || IS_CONTACT || IS_SUPPORT_PAGE;
  const HOME_AI_SELECTOR = AI_SELECTORS.concat([
    '#ads-agent-host',
    '[id*="ads-agent"]',
    '[id*="brand-agent"]',
    '[class*="brand-agent"]',
    '[class*="ads-agent"]',
    '[data-ckl-ai-entrypoint]'
  ]).join(',');

  function installHomeWidgetStyles() {
    if (!USE_HOME_WIDGET_LAYOUT) return;
    document.documentElement.setAttribute('data-ckl-home-widgets', '20260922');
    if (IS_SEARCH) document.documentElement.setAttribute('data-ckl-search-widgets', '20260923');
    if (IS_COLLECTION) document.documentElement.setAttribute('data-ckl-collection-widgets', '20260923');
    if (IS_BUCKET_COLLECTION) document.documentElement.setAttribute('data-ckl-bucket-widgets', '20260922');
    if (IS_PRODUCT) document.documentElement.setAttribute('data-ckl-product-widgets', '20260922');
    if (IS_ABOUT) document.documentElement.setAttribute('data-ckl-about-widgets', '20260923');
    if (IS_LOOKBOOK) document.documentElement.setAttribute('data-ckl-lookbook-widgets', '20260923');
    if (IS_REVIEWS) document.documentElement.setAttribute('data-ckl-reviews-widgets', '20260923');
    if (IS_CONTACT) document.documentElement.setAttribute('data-ckl-contact-widgets', '20260923');
    if (IS_SUPPORT_PAGE) document.documentElement.setAttribute('data-ckl-support-widgets', '20260923');
    if (document.getElementById('ckl-home-widgets-style')) return;

    const style = document.createElement('style');
    style.id = 'ckl-home-widgets-style';
    style.textContent =
      'html[data-ckl-home-widgets] :is(' + HOME_AI_SELECTOR + '){' +
      'display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;}';
    document.head.appendChild(style);
  }

  function syncHomeWidgetInset() {
    if (!USE_HOME_WIDGET_LAYOUT && !IS_CUSTOM) return;
    const root = document.documentElement;
    let inset = IS_CUSTOM && window.innerWidth < 1000 ? 12 : 24;

    if (window.innerWidth >= 1000) {
      const viewportWidth = root.clientWidth;
      const shell = document.querySelector('.shopify-section--header .header__wrapper');
      const rect = shell?.getBoundingClientRect();
      const shellMax = parseFloat(getComputedStyle(root).getPropertyValue('--ckl-site-shell-max')) || 1200;
      const gutter = rect && rect.width > 0
        ? Math.min(rect.left, viewportWidth - rect.right)
        : Math.max(20, (viewportWidth - shellMax) / 2);
      inset = Math.max(24, gutter - 60);
    }

    root.style.setProperty('--ckl-float-inline', inset + 'px');
  }

  function hideHomeAi() {
    document.querySelectorAll(HOME_AI_SELECTOR).forEach((el) => {
      if (!isElement(el)) return;
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('opacity', '0', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
      el.setAttribute('aria-hidden', 'true');
      el.inert = true;
    });
  }

  const CHAT_SELECTORS = [
    'shopify-chat',
    'inbox-online-store-chat',
    '#ShopifyChat',
    'iframe[id*="ShopifyChat"]',
    'iframe[src*="shopifychat"]',
    'iframe[src*="inbox"]'
  ];

  const SCROLL_SELECTORS = [
    '#effectiveAppsScrollToTopBtn',
    '[id*="ScrollToTop"]',
    '[class*="scroll-to-top"]'
  ];

  const STICKY_SELECTORS = [
    '[data-pc102-sticky-bar]',
    '[data-bulk-product-sticky-bar][data-bulk-product-sticky-live]',
    '[data-bulk-product-sticky-bar]'
  ];

  function isElement(node) {
    return !!node && node.nodeType === 1;
  }

  function visibleHeight(el) {
    if (!isElement(el)) return 0;
    const rect = el.getBoundingClientRect();
    const style = getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || rect.height <= 0) return 0;
    return rect.height;
  }

  function syncFloatBottom() {
    let stickyHeight = 0;

    for (const selector of STICKY_SELECTORS) {
      const candidates = document.querySelectorAll(selector);
      for (const el of candidates) {
        stickyHeight = Math.max(stickyHeight, visibleHeight(el));
      }
    }

    const gap = window.innerWidth < 1000 ? 12 : 16;
    const fallback = window.innerWidth < 1000 ? 12 : 20;
    const bottom = stickyHeight > 0 ? Math.round(stickyHeight + gap) : fallback;

    document.documentElement.style.setProperty('--ckl-float-bottom', bottom + 'px');
  }

  function pinElement(el, side) {
    if (!isElement(el) || !el.style) return;

    el.style.setProperty('position', 'fixed', 'important');
    el.style.setProperty('top', 'auto', 'important');
    el.style.setProperty('bottom', 'var(--ckl-float-bottom)', 'important');
    el.style.setProperty('z-index', '80', 'important');

    if (side === 'left') {
      el.style.setProperty('left', 'var(--ckl-float-inline)', 'important');
      el.style.setProperty('right', 'auto', 'important');
      el.style.setProperty('transform', 'none', 'important');
    } else if (side === 'right') {
      el.style.setProperty('right', 'var(--ckl-float-inline)', 'important');
      el.style.setProperty('left', 'auto', 'important');
      el.style.setProperty('transform', 'none', 'important');
    } else {
      el.style.setProperty('left', '50%', 'important');
      el.style.setProperty('right', 'auto', 'important');
      el.style.setProperty('transform', 'translateX(-50%)', 'important');
    }
  }

  function showElement(el) {
    if (!isElement(el) || !el.style) return;
    el.style.removeProperty('display');
    el.style.setProperty('visibility', 'visible', 'important');
    el.style.setProperty('opacity', '1', 'important');
    el.style.setProperty('pointer-events', 'auto', 'important');
    el.style.removeProperty('width');
    el.style.removeProperty('height');
    el.style.removeProperty('max-width');
    el.style.removeProperty('max-height');
    el.style.removeProperty('overflow');
  }

  function markAiElement(el) {
    if (!isElement(el)) return;
    el.setAttribute('data-ckl-ai-entrypoint', 'true');
    showElement(el);
    pinElement(el, 'center');
  }

  function scanShadowForAi(host) {
    if (!host || !host.shadowRoot) return;

    AI_SELECTORS.forEach((selector) => {
      host.shadowRoot.querySelectorAll(selector).forEach(markAiElement);
    });

    const labelCandidates = host.shadowRoot.querySelectorAll('[aria-label], [title]');
    labelCandidates.forEach((el) => {
      const label = ((el.getAttribute('aria-label') || '') + ' ' + (el.getAttribute('title') || '')).trim();
      if (/shop with ai/i.test(label)) markAiElement(el);
    });
  }

  function syncAi() {
    if (USE_HOME_WIDGET_LAYOUT) {
      hideHomeAi();
      return;
    }

    const ai = keepSingleTopLevel(AI_SELECTORS);
    if (ai) markAiElement(ai);

    const aiHosts = document.querySelectorAll(
      '#ads-agent-host, [id*="ads-agent"], [id*="brand-agent"], [class*="brand-agent"], [class*="ads-agent"]'
    );

    aiHosts.forEach((host, index) => {
      if (!isElement(host)) return;

      if (index > 0) {
        markDuplicate(host);
        return;
      }

      host.removeAttribute('data-ckl-duplicate-widget');
      host.setAttribute('data-ckl-ai-entrypoint', 'true');
      showElement(host);
      // A viewport-height transparent host must not intercept page controls.
      host.style.setProperty('pointer-events', 'none', 'important');
      host.setAttribute('data-ckl-hit-test-fix', '20260922');
      pinElement(host, 'center');
      scanShadowForAi(host);

      if (host.shadowRoot) {
        let style = host.shadowRoot.querySelector('style[data-ckl-ai-position]');
        if (!style) {
          style = document.createElement('style');
          style.setAttribute('data-ckl-ai-position', 'true');
          host.shadowRoot.appendChild(style);
        }

        style.textContent = [
          ':host{position:fixed!important;left:50%!important;right:auto!important;',
          'top:auto!important;bottom:var(--ckl-float-bottom,20px)!important;',
          'transform:translateX(-50%)!important;margin:0!important;z-index:80!important;pointer-events:none!important;}',
          '.entrypoint-shadow,button,a,input,textarea,select,[role="button"],[role="dialog"]{pointer-events:auto!important;}',
          '.entrypoint-shadow,.shop-ai-chat-container,[aria-label*="Shop with AI" i],',
          '[title*="Shop with AI" i]{left:50%!important;right:auto!important;',
          'top:auto!important;bottom:0!important;transform:translateX(-50%)!important;margin:0!important;}'
        ].join('');
      }
    });
  }

  function topLevelMatches(selectors) {
    const matches = [];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        if (!isElement(el) || matches.includes(el)) return;
        matches.push(el);
      });
    });

    return matches.filter((el) => !matches.some((other) => other !== el && other.contains(el)));
  }

  function markDuplicate(el) {
    if (!isElement(el)) return;
    el.setAttribute('data-ckl-duplicate-widget', 'true');
  }

  function keepSingleTopLevel(selectors, preferredId) {
    const candidates = topLevelMatches(selectors);
    if (!candidates.length) return null;

    const primary = candidates.find((el) => preferredId && el.id === preferredId)
      || candidates.find((el) => visibleHeight(el) > 0) || candidates[0];
    candidates.forEach((el) => {
      if (el === primary) {
        el.removeAttribute('data-ckl-duplicate-widget');
      } else {
        markDuplicate(el);
      }
    });

    return primary;
  }

  function usesBulkWidgetPositioning() {
    return IS_PRODUCT && !!window.__bulkProductPageScriptLoaded
      && !!document.querySelector('[data-bulk-product-pdp]');
  }

  function syncChat() {
    const chat = keepSingleTopLevel(CHAT_SELECTORS);
    if (!chat) return;

    chat.setAttribute('data-ckl-chat-host', 'true');
    if (usesBulkWidgetPositioning()) return;

    const tag = String(chat.tagName || '').toLowerCase();
    if (tag !== 'shopify-chat') {
      pinElement(chat, 'left');
    }

    if (chat.shadowRoot) {
      let style = chat.shadowRoot.querySelector('style[data-ckl-chat-position]');
      if (!style) {
        style = document.createElement('style');
        style.setAttribute('data-ckl-chat-position', 'true');
        chat.shadowRoot.appendChild(style);
      }
      // Keep the native chat overlay viewport-sized; only the launcher is offset.
      // Pinning both its wrapper and nested button can apply the inset twice.
      // The hydrated Inbox runtime exposes its launcher through an exported part.
      const css = [
        tag === 'shopify-chat'
          ? ':host{position:fixed!important;inset:0!important;width:100%!important;height:100%!important;margin:0!important;transform:none!important;pointer-events:none!important;}'
          : '',
        'shopify-agent-runtime::part(activator),.activator-nudge,[part~="activator"]:not(.activator-nudge [part~="activator"]){position:fixed!important;left:var(--ckl-float-inline,24px)!important;right:auto!important;bottom:var(--ckl-float-bottom,20px)!important;top:auto!important;margin:0!important;transform:none!important;pointer-events:auto!important;}',
        '.activator-nudge [part~="activator"]{position:static!important;inset:auto!important;margin:0!important;transform:none!important;pointer-events:auto!important;}'
      ].join('');
      if (style.textContent !== css) style.textContent = css;
      style.setAttribute('data-ckl-chat-position', 'single-anchor-v2');
    }
  }

  function syncScrollTop() {
    const singleScrollControl = IS_SEARCH || IS_COLLECTION || IS_PRODUCT || IS_ABOUT || IS_LOOKBOOK || IS_REVIEWS || IS_CONTACT || IS_SUPPORT_PAGE;
    const selectors = singleScrollControl ? SCROLL_SELECTORS.concat('.usf-goto-top') : SCROLL_SELECTORS;
    const el = keepSingleTopLevel(selectors, singleScrollControl ? 'effectiveAppsScrollToTopBtn' : null);
    if (usesBulkWidgetPositioning()) return;
    if (!el) return;

    const parent = el.parentElement;
    const target = parent && parent.childElementCount === 1 ? parent : el;

    target.removeAttribute('data-ckl-duplicate-widget');
    target.setAttribute('data-ckl-scroll-top', 'true');
    pinElement(target, 'right');

    if (target !== el && el.style) {
      el.style.setProperty('position', 'static', 'important');
      el.style.setProperty('left', 'auto', 'important');
      el.style.setProperty('right', 'auto', 'important');
      el.style.setProperty('top', 'auto', 'important');
      el.style.setProperty('bottom', 'auto', 'important');
      el.style.setProperty('transform', 'none', 'important');
    }
  }

  function syncAll() {
    syncHomeWidgetInset();
    syncFloatBottom();
    syncAi();
    syncChat();
    syncScrollTop();
  }

  let raf = 0;
  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      syncAll();
    });
  }

  installHomeWidgetStyles();
  syncHomeWidgetInset();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  window.addEventListener('load', schedule, { once: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule, { passive: true });

  const WATCH_SELECTOR = [
    ...AI_SELECTORS,
    ...CHAT_SELECTORS,
    ...SCROLL_SELECTORS,
    ...STICKY_SELECTORS,
    '#ads-agent-host',
    '[id*="ads-agent"]',
    '[id*="brand-agent"]',
    '[class*="brand-agent"]',
    '[class*="ads-agent"]'
  ].join(',');

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!isElement(node)) continue;
        if (node.matches?.(WATCH_SELECTOR) || node.querySelector?.(WATCH_SELECTOR)) {
          schedule();
          return;
        }
      }
    }
  });
  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true
  });

  // Event-driven updates handle normal widget hydration. Keep only two bounded
  // fallback passes for late third-party mounts instead of polling every 500ms.
  window.setTimeout(schedule, 1200);
  window.setTimeout(schedule, 3500);
})();
